define('presentation/signup/viewModels/signupAsideViewModel',[
        'businessServices/signup/signupSessionStore',
        'common/promises/promiseFactory',
        'persistence/repositories/signupRepository'
    ],
    function() {
        return function() {
            const self = this;

            const PromiseFactoryConstructor = require('common/promises/promiseFactory');
            const _promiseFactory = new PromiseFactoryConstructor();

            const SignupSessionStoreConstructor = require('businessServices/signup/signupSessionStore');

            const _i18n = require('i18next');

            let _disposables = [];
            let _signupRepository = null;
            let _signupSessionStore = null;

            const HostedNumbersAffiliateCode = "HNC";

            self.sections = ko.observableArray([]);

            const _getAffiliateCode = (signupDocument) => {
                return _promiseFactory.defer(promise => {
                    _signupSessionStore.getAffiliates()
                        .fail(promise.reject)
                        .done((result) => {
                            const affiliate = result.affiliates.find((affiliate) => {
                                return affiliate.affiliateCode === signupDocument.affiliateId;
                            });
                            promise.resolve(affiliate ? affiliate.affiliateCode : '');
                        });
                });
            };

            const _updateAsideContent = (affiliateCode) => {
                const sections = [
                    {
                        header: _i18n.t('signupAside:trialHeader'),
                        body: _i18n.t('signupAside:trialMessage'),
                    }
                ];

                if (affiliateCode !== HostedNumbersAffiliateCode) {
                    sections.push({
                        header: _i18n.t('signupAside:readyHeader'),
                        body: _i18n.t('signupAside:readyMessage'),
                    });
                }

                self.sections(sections);
            };

            const _refreshSignupAside = () => {
                return _promiseFactory.defer(promise => {
                    _signupSessionStore.get(false)
                        .fail(promise.reject)
                        .done((signupDocument) => {
                            if (signupDocument === null) {
                                _updateAsideContent('');
                                promise.resolve();
                                return;
                            }

                            _getAffiliateCode(signupDocument)
                                .done((affiliateCode) => {
                                    _updateAsideContent(affiliateCode);
                                    promise.resolve();
                                });
                        });
                });
            };

            self.refresh = () => {
                return _refreshSignupAside();
            };

            self.detached = () => {
                _signupRepository.dispose();
                _disposables.forEach(subscription => subscription.dispose());
                _disposables = [];
            };

            self.activate = () => {
                const SignupRepository = require('persistence/repositories/signupRepository');
                _signupRepository = new SignupRepository();
                _signupRepository.init();

                _signupSessionStore = new SignupSessionStoreConstructor();
                _signupSessionStore.init();

                return _initialize();
            };

            const _initialize = () => {
                _refreshSignupAside();

                _signupRepository.onSignupAffiliateUpdated(() => {
                    _refreshSignupAside();
                });

                return _promiseFactory.wait();
            };
        };
    });
